/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// @store
import useServiceStore from "../../../store/useServiceRequestStore";
import useProposalStore from "../../../store/useProposalStore";

// @types
import { ServiceRequest } from "../../../types/request.types";
import { useSpinnerStore } from "../../../store/useSpinnerStore";
import { toast } from "react-toastify";

const RequestsSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { openSpinner } = useSpinnerStore();
  const { serviceListCreated, requestListByCreatedStatus, isLoading } =
    useServiceStore();
  const { proposalCounts, getProposalCount, fetchProposalsByRequest } =
    useProposalStore();
  const [selectedRequest, setSelectedRequest] = useState<string | null>(null);

  const handleServiceButtonClick = () => navigate("/categories");

  useEffect(() => {
    if (isLoading) return openSpinner(true);
    return openSpinner(false);
  }, [isLoading, openSpinner]);

  useEffect(() => {
    requestListByCreatedStatus();
  }, []);

  const handleRequestSelect = async (request: ServiceRequest) => {
    openSpinner(true);
    try {
      setSelectedRequest(request.serviceRequestId);
      await fetchProposalsByRequest(request.serviceRequestId);
      openSpinner(false);
    } catch (error) {
      openSpinner(false);
      toast.error(t("error.callList"));
    }
  };

  // Load proposals for all requests
  useEffect(() => {
    if (serviceListCreated?.items) {
      serviceListCreated.items.forEach((request: ServiceRequest) => {
        getProposalCount(request.serviceRequestId);
      });
    }
  }, [serviceListCreated?.items]);

  useEffect(() => {
    if (selectedRequest) {
      fetchProposalsByRequest(selectedRequest);
    }
  }, [selectedRequest, fetchProposalsByRequest]);

  console.log(serviceListCreated);

  return (
    <section className="p-6 ">
      <h2 className="text-[15px] font-semibold text-center mb-6">
        {t("requestsAndProposals.myRequest")}
      </h2>
      {!serviceListCreated?.items || serviceListCreated?.items.length === 0 ? (
        <div className="text-center">
          <img
            src="assets/icons/brand/no-requests.png"
            alt="No requests"
            className="mx-auto mb-4 w-48"
          />
          <h3 className="text-[15px] font-semibold mb-2">
            {t("requestsAndProposals.noRequests.title")}
          </h3>
          <p className="text-gray-600 text-[14px]">
            {t("requestsAndProposals.noRequests.description")}
          </p>
        </div>
      ) : (
        <div className="grid gap-4 max-h-[50vh] overflow-auto">
          {serviceListCreated?.items.map((request: ServiceRequest) => (
            <div
              key={request.serviceRequestId}
              className={`pr-6 pl-4 py-4 flex items-center gap-4 rounded-lg transition-all cursor-pointer ${
                selectedRequest === request.serviceRequestId
                  ? "border-2 border-red-400 shadow-md bg-[#FFF7F6]"
                  : "border-2 border-b-gray-300 shadow-lg bg-white dark:bg-dark-cBackground dark:shadow-white"
              }`}
              onClick={() => {
                handleRequestSelect(request);
              }}
            >
              <img
                src={request.category.urlImage}
                alt={request.category.name}
                className="size-32 rounded-lg object-cover"
              />
              <div className="flex-grow">
                <div className="flex justify-between items-center">
                  <h1
                    className={`font-semibold text-[15px] mb-2 ${
                      selectedRequest === request.serviceRequestId
                        ? "text-textBrand dark:text-dark-textBrand font-semibold"
                        : " text-cText dark:text-dark-cText font-medium"
                    }`}
                  >
                    {request.category.name}
                  </h1>
                  <p
                    className={` text-[13px] ${
                      selectedRequest === request.serviceRequestId
                        ? "text-textBrand dark:text-dark-textBrand font-semibold"
                        : "text-cTextSecondary font-medium dark:text-dark-cTextSecondary"
                    }`}
                  >
                    {proposalCounts[request.serviceRequestId] || 0} Propuestas
                  </p>
                </div>

                <div className="flex justify-between items-center mt-2">
                  <div className="flex flex-col gap-2">
                    {request?.services?.length &&
                      request.services.map((item) => (
                        <p
                          key={request.serviceRequestId}
                          className={`text-[14px]  ${
                            selectedRequest === request.serviceRequestId
                              ? "text-textBrand dark:text-dark-textBrand"
                              : "text-cTextSecondary dark:text-dark-cTextSecondary"
                          }`}
                        >
                          {item?.name}
                        </p>
                      ))}
                    <p className="text-cTextSecondary dark:text-dark-cTextSecondary text-[13px]">
                      {request?.serviceRequestNumber}
                    </p>
                  </div>
                  <p className="text-cTextSecondary dark:text-dark-cTextSecondary">
                    {new Date(request?.createdAt)?.toLocaleDateString()}
                  </p>
                </div>

                <div className="flex w-full mt-3 ">
                  <p className="text-cTextSecondary dark:text-dark-cTextSecondary text-[14px]">
                    {t("requestsAndProposals.expiration")}{" "}
                    {new Date(
                      new Date(request?.createdAt).getTime() +
                        (Number(proposalCounts[request.serviceRequestId]) > 0 ? 7 : 3) *
                          24 *
                          60 *
                          60 *
                          1000
                    ).toLocaleDateString()}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="mt-8 border-2 border-gray-300 rounded-lg p-2">
        <p className="text-cTextSecondary text-center text-[14px] leading-6">
          {t("requestsAndProposals.infoBox.text")}
        </p>
        <div className="flex justify-center">
          <button
            className="mt-4 bg-bgBrand text-white px-6 py-2 rounded-lg hover:bg-bgBrandHover transition-colors"
            onClick={handleServiceButtonClick}
          >
            {t("requestsAndProposals.infoBox.button")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default RequestsSection;
